import React from "react";
import { Spinner } from "@blueprintjs/core";
import "../assets/components/NewResults.css";
import "../assets/components/Result.css";

import NoResults from '../components/Results/NoResults'
import SessionNotFound from '../components/Results/SessionNotFound'
import PairComparaisonResults from '../components/Results/PairComparaisonResults'
import MultipleCriteriasResults from '../components/Results/MultipleCriteriasResults'
import MultipleChannelResults from '../components/Results/MultipleChannelResults'
import ManualChoiceResults from '../components/Results/ManualChoiceResults'
import { changeLanguage } from "utlis/translations/i18n";
import Session from "../services/Session";
import { base } from "../fire";

class NewResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = { session: null, instances: [], loading: true };
        this.sessionId = this.props.match.params.id;
        this.userId = this.props.match.params.uid;
    }

    render() {
        const { instances = [], loading, session = {} } = this.state;

        let results = null;
        let feedbacks = null;


        if (loading) return <Spinner className="margin-top-medium" />;

        if (session == null) return <SessionNotFound />

        if ((instances.length === 0 || !instances)) return <NoResults />

        results = Session.getResultsForSession(session, instances);
        feedbacks = Session.getFeedbackAnswersForSession(session, instances);

        switch (session.metadata.protocol) {
            case "PC" /** Pair comparaison */:
                return (
                    <PairComparaisonResults
                        session={session}
                        results={results}
                        instances={instances}
                        feedbacks={feedbacks}
                    />
                );
            case "MS" /** Multiple Criterieas */:
                return (
                    <MultipleCriteriasResults
                        session={session}
                        results={results}
                        instances={instances}
                        feedbacks={feedbacks}
                    />
                );
            case "MC" /** Multiple Channels */:
                return (
                    <MultipleChannelResults
                        session={session}
                        results={results}
                        instances={instances}
                        feedbacks={feedbacks}
                    />
                );
            case "CM" /** Manual Choice */:
                return (
                    <ManualChoiceResults
                        session={session}
                        results={results}
                        instances={instances}
                        feedbacks={feedbacks}
                    />
                );
            default:
                return <div>Unknown protocol</div>;
        }
    }

    componentDidMount() {
        /**
         * TODO: Check if we don't have the same issue that we had on user
         * (because we set sessionId in constructor and we need a refresh to update the value)
         */
        Session.getSessionByIdAndUid(this.userId, this.sessionId).then(session => {
            if (!session) return this.setState({ loading: false, session: null });
            this.setState({ session });
            if (session.metadata.language) {
                changeLanguage(session.metadata.language);
              }
            this.syncSessionInstances = Session.syncSessionInstances(session.id, {
                context: this,
                state: "instances",
                asArray: true,
                then: () => this.setState({ loading: false })
            });
        });
        document.body.style.background = "#080808";
    }

    componentWillUnmount() {
        document.body.style.background = null;
        if (this.syncSessionInstances)
            base.removeBinding(this.syncSessionInstances);
    }
}

export default NewResults;
